import { Observable } from 'rxjs';
import { User } from '../../Models/User/User';
import { BACK_URL } from '../../Utils/Constants';
import { Request } from '../Request/Request';
import { AuthenticationManagerRepresentable } from './AuthenticationManager.interface';

export class AuthenticationManager implements AuthenticationManagerRepresentable {
  public authenticate(token: string): Observable<User> {
    return new Request(BACK_URL)
      .withPath('/auth')
      .withHeaders({
        Authorization: token
      })
      .get();
  }
}
